import { useNavigate } from "react-router-dom";

import { useModalContext } from "../../../Contexts/ModalContext";

import { BankIcon, VenmoLogo } from "../../../Assets/Images";

import { modalVariants } from "../../../Utils/constants";
import { ChevronRight } from "../../../Assets/Icons";

export default function renderCashOutUsingPaymentEntity(modalContext) {
  const { updateModalComponent, setModalTitle, setModalVariant } = modalContext;

  updateModalComponent(() => <CashOutUsingPaymentEntity />);
  setModalTitle("Cash Out");
  setModalVariant(modalVariants.formDialog);
}

export const CashOutUsingPaymentEntity = () => {
  const modalContext = useModalContext();
  const { onModalClose } = modalContext;

  const navigate = useNavigate();

  const handleOnPaymentEntityClick = (transferRoute) => {
    navigate(transferRoute);
    onModalClose();
  };

  return (
    <>
      <div className="modal-dialog-content mb-6">
        <div className="funding-instrument-options">
          <button className="funding-instrument-option" onClick={handleOnPaymentEntityClick.bind(this, "/cash-out")}>
            <div className="funding-instrument">
              <div className="funding-instrument-icon-wrapper">
                <BankIcon className="funding-instrument-icon" />
              </div>
              <div className="funding-instrument-details">
                <h4 className="funding-instrument-title">Standard transfer</h4>
                <span className="funding-instrument-description">1-3 business days. Always free</span>
              </div>
            </div>
            <ChevronRight className="chevron" />
          </button>
          <button
            className="funding-instrument-option"
            onClick={handleOnPaymentEntityClick.bind(this, "/venmo-transfer")}
          >
            <div className="funding-instrument">
              <div className="funding-instrument-icon-wrapper">
                <VenmoLogo className="funding-instrument-icon" />
              </div>
              <div className="funding-instrument-details">
                <h4 className="funding-instrument-title">Venmo Transfer</h4>
                <span className="funding-instrument-description">
                  Instant transfer to the Venmo linked to your number.
                </span>
              </div>
            </div>
            <ChevronRight className="chevron" />
          </button>
        </div>
      </div>
    </>
  );
};
